import React from 'react';

import Button from '@/components/Button';
import Map from '@/components/Map';
import { telPhone } from '@/lib/Utils';

import LocationPin from '@/images/icons/pin.svg';

import styles from './styles.module.scss';

interface Props {
  location: LocationsLocationBlockType;
}

const LocationCard = ({ location }: Props) => {
  return (
    <div key={location.description} className={styles.locationCard}>
      <Map lat={location?.address?.lat} lng={location?.address?.lng} width={424} height={264} zoom={14} />
      <h3>{location.description}</h3>
      <div className={styles.location}>
        <LocationPin />
        {location?.address?.address}
      </div>
      <div className={styles.cta}>
        {location.phone && (
          <a className={styles.phone} href={`tel:${telPhone(location.phone)}`}>
            {location.phone}
          </a>
        )}
        {location.website && (
          <div className={styles.website}>
            <Button
              href={location.website}
              target="_blank"
              rel="noreferrer noopener"
              design="highlight-borders"
              size="small"
            >
              Visit website
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationCard;
